import React, {useState} from "react";
import {Accordion, AccordionTab} from 'primereact/accordion';
import GeneralUtils from "../../utils/GeneralUtils";
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import "./CourseCurriculum.css";
import CoursePreview from "./CoursePreview";

const playIcon = "/icons/play-button.png";
const docIcon = "/icons/google-docs.png";
const queryIcon = "/icons/question-sign.png";

const CourseCurriculum = (props) => {
    const {data, title, numOfPublishedLectures, contentInfo} = props;
    const [activeIndex, setActiveIndex] = useState();
    const [allOpen, setAllOpen] = useState(false);
    const [displayDialog, setDisplayDialog] = useState(false);
    const [preview, setPreview] = useState(null);

    const imageTypeHandler = (list) => {
        if (list.type === "doc") {
            return docIcon;
        } else if (list.type === "query") {
            return queryIcon;
        } else {
            return playIcon;
        }
    };

    const toggle = (itemIndex) => {
        let _activeIndex = activeIndex ? [...activeIndex] : [];
        if (allOpen) {
            _activeIndex = [];
        } else {
            for (let i = 0; i < data.length; i++) {
                _activeIndex[i] = i;
            }
        }
        setAllOpen(!allOpen)
        setActiveIndex(_activeIndex);
    }

    const onPreview = (lecture) => {
        // if (lecture.canBePreviewed) {
        //     setDisplayDialog(true);
        //     setPreview(lecture);
        // }
    }

    if (!GeneralUtils.isNullOrEmpty(data)) {
        return (
            <div className="course-curriculum">
                <div className="align-center">
                    <p>{data?.length} bölüm • {numOfPublishedLectures} ders • {contentInfo}</p>
                    <Button icon={allOpen ? 'pi pi-minus' : 'pi pi-plus'} label="Tüm bölümleri genişlet" onClick={() => toggle(0)}
                            className="p-button-text p-button-sm" style={{fontSize: "0.9rem", margin: "0.5rem", padding: "0.3rem 0"}}/>
                </div>

                <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    {data?.sort(GeneralUtils.compareIndex).map((chapter, index) => (
                        <AccordionTab key={chapter.id} header={
                            <div className="align-center">
                                {chapter.objectIndex}: {chapter.title}
                                <p className="item-info-right">{chapter.lectureList?.length} ders • {chapter.contentLengthText}</p>
                            </div>}>

                            {chapter.lectureList?.sort(GeneralUtils.compareIndex).map((lecture, i) => (
                                <div className={"course-item "
                                    // + (lecture.canBePreviewed && "previewButton")
                                } key={lecture.id} onClick={() => onPreview(lecture)}>

                                    {/*<img src={imageTypeHandler((Math.random() > 0.5) ? 'play' : 'doc')} alt="icon"*/}
                                    {/*     className="course-icon"/>*/}
                                    <i className="pi pi-video course-icon" style={{ fontSize: '0.8rem'}}/>
                                    <div className="align-center">
                                        <p
                                            // className={lecture.canBePreviewed && "previewButton"}
                                        >{lecture.title}</p>
                                        {/*{lecture.canBePreviewed && <p className={lecture.canBePreviewed && "previewButton"}>Önizleme</p>}*/}
                                    </div>

                                    <p className="item-info-right">{lecture.contentSummary}</p>
                                </div>
                            ))}

                        </AccordionTab>
                    ))}
                </Accordion>
                <Dialog header={title} visible={displayDialog} onHide={() => setDisplayDialog(false)} position='top' style={{width: '40vw'}}>
                    <CoursePreview data={data} preview={preview}/>
                </Dialog>
            </div>
        );
    }
}
export default CourseCurriculum;